var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#3282FF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14C2.725 14 2.48958 13.9021 2.29375 13.7063C2.09792 13.5104 2 13.275 2 13V4.18333C2 4.07353 2.01667 3.96765 2.05 3.86568C2.08333 3.76373 2.13333 3.66961 2.2 3.58333L3.06667 2.4C3.15556 2.27778 3.27189 2.18056 3.41568 2.10833C3.55947 2.03611 3.7098 2 3.86667 2H12.1167C12.2735 2 12.4239 2.03611 12.5677 2.10833C12.7114 2.18056 12.8278 2.27778 12.9167 2.4L13.8 3.58333C13.8667 3.66961 13.9167 3.76373 13.95 3.86568C13.9833 3.96765 14 4.07353 14 4.18333V13C14 13.275 13.9021 13.5104 13.7063 13.7063C13.5104 13.9021 13.275 14 13 14H3ZM3.28333 3.76667H12.7L12.0932 3H3.88333L3.28333 3.76667ZM10.6667 4.76667H5.33333V6.43614H8H10.6667V4.76667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox);
export default __webpack_public_path__ + "static/media/icon-box.3e343dcefffdefead0f6a3fe80ae11b3.svg";
export { ForwardRef as ReactComponent };